/**
 * The confirm every poster / Permits logger sees before a permit update goes to the client (Matt,
 * 2026-09-23): the exact wording they wrote, who gets it, and that it goes out as written. Resolves
 * true to go ahead. A project with no Client Hub sends nothing to the client, so there is nothing
 * to confirm. `reach` comes from services/permitting.js#getClientReach.
 */
import { confirmDialog } from './Dialog.jsx'

export async function confirmClientUpdate({ reach, agencies, memo, confirmLabel, silent }) {
  if (!reach || !reach.hasJourney) return true
  const who = silent
    ? 'It shows on the client\'s Permitting page. No email goes to subscribers.'
    : reach.held
    ? 'A game-changing comment on this project hasn\'t been acknowledged yet, so this update will wait and go out when it is acknowledged on the Tower.'
    : reach.subscribers
      ? `${reach.subscribers} ${reach.subscribers === 1 ? 'person gets' : 'people get'} this by email, and it shows on the client's Permitting page.`
      : 'No one is subscribed to email updates, so it only shows on the client\'s Permitting page.'
  const body = [
    (agencies && agencies.length ? agencies.join(', ') + ': ' : '') + (reach.clientLabel || 'Update'),
    memo && memo.trim() ? '"' + memo.trim() + '"' : '(No memo. The client sees only the line above.)',
  ].join('\n')
  return confirmDialog({
    title: 'This sends an update to the client',
    message: `${who}\n\nWhat the client will read:\n\n${body}\n\nIt goes out exactly as written. Read it once more before you confirm.`,
    confirmLabel: confirmLabel || 'Send to client',
  })
}
